import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import styles from './LoginAsNotice.module.scss';

const messages = defineMessages({
  refused: {
    id: 'app.sml.loginAs.notice.refused',
    defaultMessage: 'This login link is not valid any more. Open the user in the admin and press the button again.',
  },
  ended: {
    id: 'app.sml.loginAs.notice.ended',
    defaultMessage: 'The admin session ended after one hour.',
  },
});

export type LoginAsNoticeKind = keyof typeof messages;

interface LoginAsNoticeProps {
  kind: LoginAsNoticeKind;
}

/** The full-page message of a login-as link that does not work, and of an admin session that ended. */
const LoginAsNoticeComponent: React.FC<LoginAsNoticeProps> = ({ kind }) => {
  const intl = useIntl();
  return (
    <main className={styles.page}>
      <p className={styles.message} role="alert" data-testid={`login-as-notice-${kind}`}>
        {intl.formatMessage(messages[kind])}
      </p>
    </main>
  );
};

export const LoginAsNotice = TypedMemo(LoginAsNoticeComponent);
